import React from "react";
import { Breadcrumb } from "../../../../components/Breadcrumb";
import { NewButton, SaveButton } from "../../../../components/Buttons";

export const PriceTypes = () => {
    document.title = "Qiymət tipləri";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Məhsullar", value: "/products" },
        { name: "Parametrlər", value: "/products/parameters" },
        { name: "Qiymət tipləri", value: "/products/parameters/pricetypes", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Qiymət tipləri</h2>
                    <p>
                        Bir məhsula bir neçə qiymət təyin etmək olar. <NewButton>Yeni qiymət</NewButton> düyməsinə sıxıb açılan pəncərədə qiymət tipinin adını
                        qeyd edib <SaveButton /> düyməsini sıxmaq lazımdır. Daha sonra məhsul yaratmaq üçün açılmış pəncərədə məhsula yeni qiymət tipi təyin
                        edib <SaveButton /> düyməsini sıxa bilərsiniz.
                    </p>
                    <img src="/images/products/parameters/pricetypes.gif" alt="Qiymət tipləri" />
                </article>
            </div>
        </div>
    );
};
